export default "__VITE_ASSET__DkNZn5Qv__"